



















import { defineComponent, PropType } from "@vue/composition-api";
import { Tab } from "@/types";
import { TabType } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import CustomScroll from "@/components/CustomScroll";

export default defineComponent({
  name: "BubbleTabs",
  components: { BaseIcon, CustomScroll },
  props: {
    tabs: { type: Array as PropType<Tab[]>, required: true },
    value: {},
  },
  setup(props, { emit }) {
    const onClick = (value: string) => value !== props.value && emit("input", value);
    return { onClick, TabType };
  },
});
